import { useState } from "react";
import { useTranslation } from "react-i18next";
import AppButton from "../../../ui/buttons/AppButton";

/** Confirm the newer proposals a merge closes before its conditional writes; with none to close, merge at once. */
export default function MergeActions({ newerCount, disabled, onMerge }: { newerCount: number; disabled: boolean; onMerge: () => void }) {
  const { t } = useTranslation();
  const [state, setState] = useState<"idle" | "confirming">("idle");
  return <div className="space-y-2">
    {state === "confirming" ? <div role="group" aria-label={t("data.lineage.merge")}>
      <p>{t("data.lineage.confirm", { count: newerCount })}</p>
      <AppButton size="sm" variant="primary" disabled={disabled} onClick={() => { setState("idle"); onMerge(); }}>{t("data.lineage.merge")}</AppButton>
      <AppButton size="sm" disabled={disabled} onClick={() => { setState("idle"); }}>{t("common.cancel")}</AppButton>
    </div> : <AppButton size="sm" variant="primary" disabled={disabled} onClick={() => { if (newerCount === 0) onMerge(); else setState("confirming"); }}>{t("data.lineage.merge")}</AppButton>}
  </div>;
}
